module.exports = __webpack_public_path__ + "static/media/1011954.094ba620.png";